import React, { useState, useEffect } from "react";
import OTPInput from "react18-input-otp";
import styles from "./Login.module.css";
import axios from "axios";
import { apiUrl } from "../../Constants/Constants";
import { AuthContext } from "../../Constants/AuthProvider";
import irluxepic from "./../../images/irluxe-black.png";
import { toast } from "react-toastify";
import ReferralLogin from "./ReferralLogin.module";
import LoadingCircl from "../../Components/LoadingCircl/LoadingCircl.module";
import { toPersian } from "../../Utility/Utilities";
const Login = () => {
  const { onLogin } = React.useContext(AuthContext);
  const [step, setStep] = useState(1); // کنترل مرحله
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState(""); // کد تایید
  const [timer, setTimer] = useState(60); // تایمر 60 ثانیه‌ای
  const [canResend, setCanResend] = useState(false); // قابلیت ارسال مجدد کد
  const [loading, setLoading] = useState(false); // مدیریت وضعیت ارسال درخواست
  const [error, setError] = useState("");
  const [loginReferral, setLoginReferral] = useState(false);

  const [loginMode, setLoginMode] = useState("mobile");
  useEffect(() => {}, [loginMode]);

  useEffect(() => {
    if (step === 2 && timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(countdown);
    } else if (timer === 0) {
      setCanResend(true);
    }
  }, [step, timer]);

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    setLoginMode("mobile");
    senders();
  };
  const senders = async () => {
    if (username !== "") {
      setLoading(true);
      try {
        // ارسال درخواست به سرور
        const response = await axios.post(apiUrl + "user/login/", {
          username,
        });

        if (response.data.status === "200") {
          setStep(2);
          if (response.data !== "Sent" && response.data.data.remainingtime) {
            toast.error(
              "پس از " +
                response.data.data.remainingtime +
                " ثانیه مجددا تلاش نمایید."
            );
            setTimer(response.data.data.remainingtime); // شروع مجدد تایمر
            setCanResend(false);
          } else {
            setTimer(60); // شروع مجدد تایمر
            setCanResend(false);
          }
        } else {
          toast.error("کاربر یافت نشد.");
        }
      } catch (err) {
        console.error("Error sending OTP:", err);
        setError("خطایی رخ داده است. لطفاً دوباره تلاش کنید.");
      } finally {
        setLoading(false);
      }
    }
  };
  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    let data = {};
    let url = "";
    if (loginMode === "mobile") {
      data = {
        username,
        otp,
      };
      url = "user/verify-otp/";
    } else if (loginMode === "password") {
      data = {
        username,
        password,
      };
      url = "user/verify-password/";
    }

    try {
      // ارسال کد تایید به سرور
      const response = await axios.post(apiUrl + url, data);

      if (response.status === 200) {
        if (response.data.status == "200") {
          onLogin(response.data.data.access_token, response.data.data.name);
        } else {
          if (loginMode == "password") {
            toast.error("رمز وارد شده صحیح نیست.");
          } else {
            toast.error("کد وارد شده صحیح نیست.");
          }
        }
      }
    } catch (err) {
      setError("خطایی رخ داده است. لطفاً دوباره تلاش کنید.");
    } finally {
      setLoading(false);
    }
  };
  const handleInputChange = (value) => {
    if (/^\d*$/.test(value)) {
      setUsername(value);
    }
  };

  const resendCode = () => {
    senders();
  };

  const goBack = () => {
    setStep(1);
    setOtp("");
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginBox}>
        {/* <div className={styles.boxOfBack}></div>
        <div className={styles.boxOfBack2}></div>
        <div className={styles.boxOfBac3}></div> */}
        {loading && <LoadingCircl />}
        <div className={styles.boxOfContain}>
          {loginReferral ? (
            <ReferralLogin setLoginReferral={setLoginReferral} />
          ) : (
            <>
              {step === 1 && (
                <>
                  <div className={styles.topLogin}>
                    <div className={styles.logo}>
                      <img src={irluxepic} />
                    </div>
                  </div>
                  <div className={styles.whiteBox}>
                    <form onSubmit={handleLoginSubmit} className={styles.form}>
                      <div className={styles.inputGroup}>
                        <input
                          type="tel"
                          required
                          placeholder="جهت ورود شماره موبایل خود را وارد نمایید"
                          className={styles.inputField}
                          value={username}
                          onChange={(e) => handleInputChange(e.target.value)}
                        />
                      </div>
                      <div className={styles.boxactions}>
                        <button type="submit" className={styles.loginButton}>
                          ورود به سیستم
                        </button>
                        <div
                          className={styles.yellowCta}
                          onClick={() => setLoginReferral(true)}
                        >
                          ثبت نام با کدریفرال
                        </div>
                      </div>
                    </form>
                  </div>
                </>
              )}
              {step === 2 && (
                <>
                  {loginMode === "mobile" ? (
                    <>
                      <div className={styles.topLogin}>
                        <div className={styles.logo}>
                          <img src={irluxepic} />
                        </div>
                      </div>
                      <div className={styles.whiteBox}>
                        <form
                          onSubmit={handleOtpSubmit}
                          className={styles.form}
                        >
                          <p className={styles.description}>
                            کد تأییدی که به شماره موبایل شما ارسال شده است را
                            وارد کنید.
                          </p>
                          <div className={styles.getitcenter}>
                            <OTPInput
                              value={otp}
                              onChange={setOtp}
                              numInputs={5}
                              isInputNum={true}
                              separator={<span> </span>}
                              inputStyle={{
                                width: "40px",
                                height: "40px",
                                margin: "0 5px",
                                fontSize: "18px",
                                borderRadius: "0px",
                                border: "unset",
                                borderBottom: "2px solid var(--button-text)",
                                backgroundColor: "transparent",
                                textAlign: "center",
                              }}
                              focusStyle={{
                                // border: "1px solid #007bbf",
                                // boxShadow: "0 0 5px rgba(0, 123, 191, 0.3)",
                                outline: "none",
                              }}
                            />
                          </div>
                          <div className={styles.timer}>
                            {timer > 0 ? (
                              <p>ارسال مجدد کد در: {toPersian(timer)} ثانیه</p>
                            ) : (
                              <button
                                type="button"
                                className={styles.resendButton}
                                onClick={resendCode}
                                disabled={!canResend}
                              >
                                <i className="fas fa-refresh"></i>
                                ارسال مجدد کد
                              </button>
                            )}
                          </div>
                          <div className={styles.boxactions}>
                            <button
                              type="submit"
                              className={styles.loginButton}
                            >
                              تأیید
                            </button>
                          </div>
                          <div className={styles.boxactions}>
                            <button
                              type="button"
                              className={styles.yellowCta}
                              onClick={goBack}
                            >
                              اصلاح شماره موبایل
                            </button>
                            <button
                              type="button"
                              className={styles.yellowCta}
                              onClick={() => setLoginMode("password")}
                            >
                              ورود با رمز عبور
                            </button>
                          </div>
                        </form>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className={styles.topLogin}>
                        <div className={styles.logo}>
                          <img src={irluxepic} />
                        </div>
                      </div>
                      <div className={styles.whiteBox}>
                        <form
                          onSubmit={handleOtpSubmit}
                          className={styles.form}
                        >
                          <p className={styles.description}>
                            شماره موبایل: {username}
                          </p>
                          <div className={styles.inputGroup}>
                            <input
                              type="password"
                              required
                              placeholder="رمز عبور را وارد نمایید"
                              className={styles.inputField}
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                            />
                          </div>

                          <div className={styles.boxactions}>
                            <button
                              type="submit"
                              className={styles.loginButton}
                            >
                              تأیید
                            </button>
                          </div>
                          <div className={styles.boxactions}>
                            <button
                              type="button"
                              className={styles.yellowCta}
                              onClick={goBack}
                            >
                              اصلاح شماره موبایل
                            </button>
                            <button
                              type="button"
                              className={styles.yellowCta}
                              onClick={handleLoginSubmit}
                            >
                              ورود با رمز یکبار مصرف
                            </button>
                          </div>
                        </form>
                      </div>
                    </>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
